import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/henri.webp';
import screenshot_target from '../../../images/letterfunnel/fidovandenbos.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Fido van den Bos"
      firstname="Fido"
      companyname="Henri"
      competition="StarCuisine en Marfo"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/fidovandenbos.js